import "./Login.html";
import "./Login.scss";

import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import LoginComponentController from "./LoginComponentController";

export default class LoginComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    constructor() {
        this.controller = LoginComponentController;
        this.templateUrl = "/App/Components/Login/Login.html";
    }
}

module("mmManagePortal").component("mmLogin", new LoginComponent());
